<template>
    <div class="wy-page-detail-container">
        <template v-if="pageName && !inDialog">
            <div class="wy-page-name">{{ pageName }}</div>
        </template>
        <template v-if="pageConfig.layout && displayFields && displayFields.length">
            <el-form :model="dataForm" :rules="formRules" ref="refForm" :label-position="pageConfig.layout.labelPosition">
                <!--行布局-->
                <template v-if="pageConfig.layout.display == 'row'">
                    <div class="wy-content-rbox">
                        <!--行区块-->
                        <div class="wy-row-box" v-for="rowIndex in rowCount" :key="rowIndex">
                            <template v-for="(item, index) in displayFields" v-if="index >= (rowIndex - 1) * countInRow && index < rowIndex * countInRow">
                                <!--自定义组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box"
                                    :prop="item.field"
                                    :key="index"
                                    :rules="
                                        item.required ? [{ required: true, message: item.label + '不能为空', trigger: 'blur change' }] : item.rules ? item.rules : []
                                    "
                                    v-if="item.type == 'custom'"
                                >
                                    <component
                                        v-model="dataForm[item.field]"
                                        :is="item.name"
                                        :fieldValue="dataForm[item.field] ? dataForm[item.field] : (item.defaultValue ? item.defaultValue : '')"
                                        :fieldConfig="item"
                                        @change="customFieldChange">
                                    </component>
                                </el-form-item>

                                <!--输入框组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box"
                                    :prop="item.field"
                                    :key="index"
                                    :rules="
                                        item.required ? [{ required: true, message: item.label + '不能为空', trigger: 'blur' }] : item.rules ? item.rules : []
                                    "
                                    v-if="item.type == 'input' || item.type == 'number' || item.type == 'textarea' || item.type == 'hidden'"
                                >
                                    <el-input
                                        v-model="dataForm[item.field]"
                                        :placeholder="item.placeholder ? item.placeholder : '请输入' + item.label"
                                        clearable
                                        @input="inputEvent(item)"
                                        :disabled="item.disabled ? item.disabled : false"
                                        v-if="item.type == 'input'"
                                    >
                                        <template slot="append" v-if="item.append">{{ item.append}}</template>
                                    </el-input>
                                    <el-input-number
                                        v-model="dataForm[item.field]"
                                        :min="1"
                                        :max="999999"
                                        v-else-if="item.type == 'number'"
                                        :disabled="item.disabled ? item.disabled : false"
                                    >
                                    </el-input-number>
                                    <el-input type="hidden" v-model="dataForm[item.field]" v-else-if="item.type == 'hidden'"> </el-input>
                                    <el-input
                                        type="textarea"
                                        :rows="item.rows ? item.rows : 5"
                                        :placeholder="item.placeholder ? item.placeholder : '请输入' + item.label"
                                        v-model="dataForm[item.field]"
                                        :disabled="item.disabled ? item.disabled : false"
                                        v-else
                                    >
                                    </el-input>
                                    <div v-if="item.tips" class="item-tips">{{ item.tips }}</div>
                                </el-form-item>
                                <!--选择框组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box"
                                    :prop="item.field"
                                    :key="index"
                                    :rules="
                                        item.required ? [{ required: true, message: item.label + '不能为空', trigger: 'change' }] : item.rules ? item.rules : []
                                    "
                                    v-else-if="item.type == 'select' || item.type == 'date' || item.type == 'checkbox' || item.type == 'radio'"
                                >
                                    <el-select
                                        v-model="dataForm[item.field]"
                                        :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label"
                                        :multiple="item.multiple ? item.multiple : false"
                                        clearable
                                        filterable
                                        :disabled="item.disabled ? item.disabled : false"
                                        v-if="item.type == 'select'"
                                    >
                                        <el-option v-for="opItem in item.options" :key="opItem.label + opItem.value" :label="opItem.label" :value="opItem.value"></el-option>
                                    </el-select>
                                    <el-date-picker
                                        v-model="dataForm[item.field]"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期"
                                        :disabled="item.disabled ? item.disabled : false"
                                        :picker-options="datepickerOptions[item.field]"
                                        v-else-if="item.type == 'date'"
                                    >
                                    </el-date-picker>
                                    <!-- 复选框 -->
                                    <el-checkbox-group
                                        v-model="dataForm[item.field]"
                                        v-else-if="item.type == 'checkbox'"
                                        :disabled="item.disabled ? item.disabled : false"
                                    >
                                        <el-checkbox v-for="(optItem, optIndex) in item.options" :key="optIndex" :label="optItem.value"
                                            >{{ optItem.label }}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                    <!-- 单选 -->
                                    <el-radio-group
                                        v-model="dataForm[item.field]"
                                        v-if="item.type == 'radio'"
                                        :disabled="item.disabled ? item.disabled : false"
                                    >
                                        <el-radio v-for="(optItem, optIndex) in item.options" :key="optIndex" :label="optItem.value"
                                            >{{ optItem.label }}
                                        </el-radio>
                                    </el-radio-group>
                                    <div v-if="item.tips" class="item-tips">{{ item.tips }}</div>
                                </el-form-item>
                                <!--上传多张图片组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box"
                                    :key="index"
                                    :prop="item.field"
                                    :rules="
                                        item.required ? [{ required: true, message: '请上传图片', trigger: 'change' }] : item.rules ? item.rules : []
                                    "
                                    v-else-if="item.type == 'uploadImg'">
                                    <wy-upload-multi-img
                                        title=""
                                        :upload-api="global.getUploadApi()"
                                        :headers="global.getUploadHeaders()"
                                        inner-style="font-size: inherit;width: auto;"
                                        accept=".jpg,.jpeg,.png,.gif"
                                        v-model="dataForm[item.field]"
                                        arrage-type="row"
                                        :show-type-tips="false"
                                        :limit="item.limit ? item.limit : 3"
                                        @change="uploadImgChange"
                                    ></wy-upload-multi-img>
                                </el-form-item>
                                <!--显示组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box show-item"
                                    :key="index"
                                    :prop="item.field" v-else-if="item.type == 'label'">
                                    <div :style="item.style ? item.style : ''">{{ dataForm[item.field] }}<span v-if="item.append">&nbsp;{{ item.append }}</span></div>
                                </el-form-item>
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box show-item json-item"
                                    :key="index"
                                    :prop="item.field" v-else-if="item.type == 'json'">
                                    <pre>{{ callDynamicMethod(item.formatFn, dataForm[item.field]) }}</pre>
                                </el-form-item>
                            </template>
                        </div>
                    </div>
                </template>
                <!--列布局-->
                <template v-if="pageConfig.layout.display == 'column'">
                    <div class="wy-content-cbox">
                        <div class="wy-column-box" v-for="colIndex in columnCount" :key="colIndex">
                            <template v-for="(item, index) in displayFields" v-if="index >= (colIndex - 1) * countIncolumn && index < colIndex * countIncolumn">
                                <!--自定义组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box"
                                    :prop="item.field"
                                    :key="index"
                                    :rules="
                                        item.required ? [{ required: true, message: item.label + '不能为空', trigger: 'blur change' }] : item.rules ? item.rules : []
                                    "
                                    v-if="item.type == 'custom'"
                                >
                                    <component
                                        v-model="dataForm[item.field]"
                                        :fieldValue="dataForm[item.field] ? dataForm[item.field] : (item.defaultValue ? item.defaultValue : '')"
                                        :is="item.name"
                                        :fieldConfig="item"
                                        @change="customFieldChange">
                                    </component>
                                </el-form-item>

                                <!--输入框组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box"
                                    :prop="item.field"
                                    :key="index"
                                    :rules="
                                        item.required ? [{ required: true, message: item.label + '不能为空', trigger: 'blur' }] : item.rules ? item.rules : []
                                    "
                                    v-if="item.type == 'input' || item.type == 'number' || item.type == 'textarea' || item.type == 'hidden'"
                                >
                                    <el-input
                                        v-model="dataForm[item.field]"
                                        :placeholder="item.placeholder ? item.placeholder : '请输入' + item.label"
                                        clearable
                                        :disabled="item.disabled ? item.disabled : false"
                                        @input="inputEvent($event, item)"
                                        v-if="item.type == 'input'"
                                    >
                                        <template slot="append" v-if="item.append">{{ item.append}}</template>
                                    </el-input>
                                    <el-input-number
                                        v-model="dataForm[item.field]"
                                        :min="1"
                                        :max="999999"
                                        v-else-if="item.type == 'number'"
                                        :disabled="item.disabled ? item.disabled : false"
                                    >
                                    </el-input-number>
                                    <el-input type="hidden" v-model="dataForm[item.field]" v-else-if="item.type == 'hidden'"> </el-input>
                                    <el-input
                                        type="textarea"
                                        :rows="item.rows ? item.rows : 5"
                                        :disabled="item.disabled ? item.disabled : false"
                                        :placeholder="item.placeholder ? item.placeholder : '请输入' + item.label"
                                        v-model="dataForm[item.field]"
                                        v-else
                                    >
                                    </el-input>
                                    <div v-if="item.tips" class="item-tips">{{ item.tips }}</div>
                                </el-form-item>
                                <!--选择框组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box"
                                    :prop="item.field"
                                    :key="index"
                                    :rules="
                                        item.required ? [{ required: true, message: item.label + '不能为空', trigger: 'change' }] : item.rules ? item.rules : []
                                    "
                                    v-else-if="item.type == 'select' || item.type == 'date' || item.type == 'checkbox' || item.type == 'radio'"
                                >
                                    <el-select
                                        v-model="dataForm[item.field]"
                                        :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label"
                                        :multiple="item.multiple ? item.multiple : false"
                                        clearable
                                        filterable
                                        :disabled="item.disabled ? item.disabled : false"
                                        v-if="item.type == 'select'"
                                    >
                                        <el-option v-for="opItem in item.options" :key="opItem.label + opItem.value" :label="opItem.label" :value="opItem.value"></el-option>
                                    </el-select>
                                    <el-date-picker
                                        v-model="dataForm[item.field]"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="datepickerOptions[item.field]"
                                        placeholder="选择日期"
                                        :disabled="item.disabled ? item.disabled : false"
                                        v-else-if="item.type == 'date'"
                                    >
                                    </el-date-picker>
                                    <!-- 复选框 -->
                                    <el-checkbox-group
                                        v-model="dataForm[item.field]"
                                        v-else-if="item.type == 'checkbox'"
                                        :disabled="item.disabled ? item.disabled : false"
                                    >
                                        <el-checkbox v-for="(optItem, optIndex) in item.options" :key="optIndex" :label="optItem.value"
                                            >{{ optItem.label }}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                    <!-- 单选 -->
                                    <el-radio-group
                                        v-model="dataForm[item.field]"
                                        v-if="item.type == 'radio'"
                                        :disabled="item.disabled ? item.disabled : false"
                                    >
                                        <el-radio v-for="(optItem, optIndex) in item.options" :key="optIndex" :label="optItem.value"
                                            >{{ optItem.label }}
                                        </el-radio>
                                    </el-radio-group>
                                    <div v-if="item.tips" class="item-tips">{{ item.tips }}</div>
                                </el-form-item>
                                <!--上传多张图片组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box"
                                    :key="index"
                                    :prop="item.field"
                                    :rules="
                                        item.required ? [{ required: true, message: '请上传图片', trigger: 'change' }] : item.rules ? item.rules : []
                                    "
                                    v-else-if="item.type == 'uploadImg'">
                                    <wy-upload-multi-img
                                        title=""
                                        :upload-api="global.getUploadApi()"
                                        :headers="global.getUploadHeaders()"
                                        inner-style="font-size: inherit;width: auto;"
                                        accept=".jpg,.jpeg,.png,.gif"
                                        v-model="dataForm[item.field]"
                                        arrage-type="row"
                                        :show-type-tips="false"
                                        :limit="item.limit ? item.limit : 3"
                                        @change="uploadImgChange"
                                    ></wy-upload-multi-img>
                                </el-form-item>
                                <!--显示组件-->
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box show-item"
                                    :key="index"
                                    :prop="item.field" v-else-if="item.type == 'label'">
                                    <div :style="item.style ? item.style : ''">{{ dataForm[item.field] }}<span v-if="item.append">&nbsp;{{ item.append }}</span></div>
                                </el-form-item>
                                <el-form-item
                                    :label="item.label"
                                    class="wy-item-box show-item json-item"
                                    :key="index"
                                    :prop="item.field" v-else-if="item.type == 'json'">
                                    <pre>{{ callDynamicMethod(item.formatFn, dataForm[item.field]) }}</pre>
                                </el-form-item>
                            </template>
                        </div>
                    </div>
                </template>
            </el-form>
        </template>
        <!--行内中按钮区块-->
        <template v-if="pageConfig.buttons && pageConfig.buttons.length">
            <div class="wy-btn-box">
                <template v-for="(buttonItem, buttonIndex) in pageConfig.buttons">
                    <component
                        :is="buttonItem.permissionID ? 'wy-permission-button':'el-button'"
                        :pID="buttonItem.permissionID ? buttonItem.permissionID : ''"
                        :type="buttonItem.type ? buttonItem.type : 'primary'"
                        :loading="buttonItem.loading ? actionLoading : false"
                        @click="buttonClickEvent(buttonItem)"
                        :key="buttonItem.label + buttonIndex"
                    >
                        {{ buttonItem.label }}
                    </component>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import moment from "moment";
import validate from "../../../utils/validate";

export default {
    name: "wy-page-detail",
    props: {
        infoId: {
            type: String,
            default: ''
        },
        saveParams: {
            type: Object,
            default: () => {}
        },
        dialogPageCode: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            // 是否是在弹框中
            inDialog: false,

            id: "",
            pageName: "",
            apiConfig: {},
            pageConfig: {},
            displayFields: [],
            countInRow: 0, // 行布局中，一行展示几个
            countIncolumn: 0, // 列布局中，一列展示几个
            rowCount: 0, // 总共多少行
            columnCount: 0, // 总共多少列
            actionLoading: false,
            dataForm: {},
            formRules: {},

            // 日期选择器配置
            datepickerOptions: {},

            // 当前登录用户信息
            user: {
                user_name: '',
                user_code: ''
            },
        };
    },
    async created() {
        let pageCode = '';
        let id = '';
        let defaultUser = localStorage.getItem(this.bizUserInfoKey);
        if(defaultUser){
             this.user = JSON.parse(defaultUser);
        }

        if (this.dialogPageCode) {
            this.inDialog = true;
            pageCode = this.dialogPageCode;
            id = this.infoId;
        } else {
            this.inDialog = false;
            pageCode = this.$route.params.pageCode;
            id = this.$route.params.id;
        }
        if (pageCode) {
            // 获取配置
            await this.getConfigInfo(pageCode);
        }
        //如果有传递相关参数，都放到dataForm中
        if (this.saveParams) {
            this.dataForm = {...this.dataForm, ...this.saveParams};
        }
        if (id) {
            // 获取详情
            this.id = id;
            if (this.apiConfig.detail) {
                await this.getDetailInfo();
            }
        }
    },
    mounted() {},
    computed: {},
    watch: {},
    methods: {
        /**
         * 动态调用方法
         * @param {string} methodName
         * @param {array} args
         * @returns {any}
         */
        callDynamicMethod(methodName, args) {
            const method = this[methodName];
            if (typeof method === 'function') {
                return method.call(this, args);
            }
        },
        /**
         * 获取页面配置信息
         * @param {string} pageCode
         */
        async getConfigInfo(pageCode) {
            let ret = await this.$wyPageApi.getPageConfig({
                page_code: pageCode,
            });
            if (ret) {
                this.pageName = ret.page_name;
                this.apiConfig = ret.api_config;
                // 处理查询参数
                let retPageConfig = await this.processDataFormItems(ret.page_config);
                this.$forceUpdate();
                // 处理布局数量
                this.countInRow = retPageConfig.layout ? retPageConfig.layout.countInRow : 0;
                this.countIncolumn = retPageConfig.layout ? retPageConfig.layout.countInColumn : 0;
                if (this.displayFields && this.displayFields.length && retPageConfig.layout) {
                    if (retPageConfig.layout.display == "row" && this.countInRow) {
                        this.rowCount = Math.ceil(this.displayFields.length / this.countInRow);
                    } else {
                        this.rowCount = this.displayFields.length;
                    }
                    if (retPageConfig.layout.display == "column" && this.countIncolumn) {
                        this.columnCount = Math.ceil(this.displayFields.length / this.countIncolumn);
                    } else {
                        this.columnCount = this.displayFields.length;
                    }
                }

                this.pageConfig = retPageConfig;
            }
        },
        /**
         * 获取页面配置中的常量配置
         */
        async getConstConfigData(item) {
            let ret = await this.$wyPageApi.getPageConfig({
                page_code: item.constOptions
            });
            if (ret && ret.page_config && Array.isArray(ret.page_config)) {
                return ret.page_config;
            }
            return [];
        },
        /**
         * 异步获取查询条件中的下拉框数据
         */
        async getSelectOptionData(item) {
            let ret = await this.$wyPageApi.requestServerApi(this.apiConfig[item.apiKey], {});
            let optionList = [];

            // 多个字段拼接的label的情况
            let arrLabelField = item.optionProps && item.optionProps.label ? item.optionProps.label.split(",") : ["label"];
            // 多个字段拼接的Value的情况
            let arrValueField = item.optionProps && item.optionProps.value ? item.optionProps.value.split(",") : ["value"];

            if (ret && Array.isArray(ret)) {
                for (let i = 0; i < ret.length; i++) {
                    let arrLabel = [];
                    let arrValue = [];
                    for (let j = 0; j < arrLabelField.length; j++) {
                        arrLabel.push(ret[i][arrLabelField[j]]);
                    }
                    for (let j = 0; j < arrValueField.length; j++) {
                        arrValue.push(ret[i][arrValueField[j]]);
                    }

                    optionList.push({
                        label: arrLabel.join(item.optionProps && item.optionProps.labelJoin ? item.optionProps.labelJoin : ""),
                        value: arrValue.join(item.optionProps && item.optionProps.valueJoin ? item.optionProps.valueJoin : ""),
                    });
                }
            } else if (ret && ret.list && ret.list.length) {
                for (let i = 0; i < ret.list.length; i++) {
                    let arrLabel = [];
                    let arrValue = [];
                    for (let j = 0; j < arrLabelField.length; j++) {
                        arrLabel.push(ret.list[i][arrLabelField[j]]);
                    }
                    for (let j = 0; j < arrValueField.length; j++) {
                        arrValue.push(ret.list[i][arrValueField[j]]);
                    }

                    optionList.push({
                        label: arrLabel.join(item.optionProps && item.optionProps.labelJoin ? item.optionProps.labelJoin : ""),
                        value: arrValue.join(item.optionProps && item.optionProps.valueJoin ? item.optionProps.valueJoin : ""),
                    });
                }
            }
            return optionList;
        },
        /**
         * 处理选择项
         */
        async processDataFormItems(pConfig) {
            if (pConfig && pConfig.fields && pConfig.fields.length) {
                for (let i = 0; i < pConfig.fields.length; i++) {
                    let fieldItem = pConfig.fields[i];
                    let defaultValue = "";
                    // 初始化数据
                    if (fieldItem.defaultValue) {
                        defaultValue = fieldItem.defaultValue;
                    } else {
                        if (fieldItem.type == "checkbox" || (fieldItem.type == "select" && fieldItem.multiple) || fieldItem.type == "uploadImg") {
                            defaultValue = [];
                        } else {
                            defaultValue = "";
                        }
                    }
                    if (fieldItem.type == "date" && fieldItem.defaultToday) {
                        defaultValue = moment(new Date()).format("YYYY-MM-DD");
                    }
                    if (fieldItem.type == "input" && fieldItem.defaultCurrentUserName) {
                        defaultValue = this.user.user_name;
                    }
                    if (fieldItem.defaultCurrentUserCode) {
                        defaultValue = this.user.user_code;
                    }
                    if ((fieldItem.type == "select" || fieldItem.type == "checkbox" || fieldItem.type == "radio") && fieldItem.apiKey) {
                        fieldItem.options = await this.getSelectOptionData(fieldItem);
                    }
                    if (fieldItem.constOptions) {
                        fieldItem.options = await this.getConstConfigData(fieldItem);
                    }
                    if (fieldItem.type == "date" && fieldItem.options) {
                        let tmpPickerOptions = {};
                        switch (fieldItem.options.disabledType) {
                            case "overDate":
                                tmpPickerOptions = {
                                    disabledDate: (time) => {
                                        return time.getTime() > new Date().getTime();
                                    },
                                };
                                break;
                            case "equalAndOverDate":
                                tmpPickerOptions = {
                                    disabledDate: (time) => {
                                        return time.getTime() >= new Date().getTime();
                                    },
                                };
                                break;
                            case "beforeDate":
                                tmpPickerOptions = {
                                    disabledDate: (time) => {
                                        return time.getTime() < new Date().getTime();
                                    },
                                };
                                break;
                            case "equalAndBeforeDate":
                                tmpPickerOptions = {
                                    disabledDate: (time) => {
                                        return time.getTime() <= new Date().getTime();
                                    },
                                };
                            default:
                                break;
                        }
                        this.$set(this.datepickerOptions, fieldItem.field, tmpPickerOptions);
                    }
                    this.$set(this.dataForm, fieldItem.field, defaultValue);
                    this.$set(this.formRules, fieldItem.field, fieldItem.rules);
                    if (fieldItem.type != "hidden") {
                        // 隐藏的字段不需要渲染
                        this.displayFields.push(fieldItem);
                    }
                }
            }

            return pConfig;
        },
        /**
         * 执行按钮点击事件
         * @param {object} item
         */
        async buttonClickEvent(item) {
            if (item.event) {
                if (item.loading) {
                    await this[item.event]();
                } else {
                    this[item.event]();
                }
            }
        },
        /**
         * 上传文件后重新校验字段
         * @param {object} file
         * @param {array} fileList
         */
        uploadImgChange(file, fileList) {
            
            this.$refs["refForm"].validate();
        },
        customFieldChange() {
            this.$refs["refForm"].validate();
        },
        async saveFormData() {
            this.$refs["refForm"].validate(async (valid) => {
                if (valid) {
                    if (this.pageConfig.beforeSaveEvents && this.pageConfig.beforeSaveEvents.length) {
                        for (let i = 0; i < this.pageConfig.beforeSaveEvents.length; i++) {
                            if (this.pageConfig.beforeSaveEvents[i]) {
                                await this[this.pageConfig.beforeSaveEvents[i]]();
                            }
                        }
                    }
                    let body = { ...this.dataForm };
                    // 处理上传多图片的字段
                    let imgFields = this.pageConfig.fields.filter((item) => item.type == "uploadImg");
                    if (imgFields && imgFields.length) {
                        for (let i = 0; i < imgFields.length; i++) {
                            let fieldItem = imgFields[i];
                            if (this.dataForm[fieldItem.field] && this.dataForm[fieldItem.field].length) {
                                body[fieldItem.field] = this.dataForm[fieldItem.field].map((item) => item.file_id);
                            }
                        }
                    }
                    // 保存
                    this.actionLoading = true;
                    try {
                        if (this.pageConfig.idKey) {
                            body[this.pageConfig.idKey] = this.id;
                        }
                        let ret = await this.$wyPageApi.requestServerApi(this.apiConfig.save, body);
                        if (ret) {
                            this.$message.success("保存成功");
                            // 或者刷新通过路径
                            /**
                             * vue-router-tab内置方法集合
                             * https://www.cnblogs.com/liao-long/p/15633540.html
                             */
                            // this.$tabs.refreshTab('/page-list/YCWB-ADMIN-DEVICE-LIST', true);
                            if (this.pageConfig.backPath) {
                                this.$tabs.open(this.pageConfig.backPath, false, true);
                            }
                            if (this.inDialog) {
                                this.$emit("reload");
                                this.$emit("close");
                            } else {
                                this.$tabs.close();
                            }
                        }
                    } catch (e) {
                        validate.displayServerError(this.$refs.refForm.fields, e.resultObject);
                    } finally {
                        this.actionLoading = false;
                    }
                } else {
                    validate.focusErrorInput();
                }
            });
        },
        closePage() {
            this.$tabs.close();
        },
        closeDialog() {
            this.$emit("close");
        },
        /**
         * 获取页面详情信息
         */
        async getDetailInfo() {
            let body = { id: this.id };
            if (this.pageConfig.idKey) {
                body = { [this.pageConfig.idKey]: this.id };
            }
            let ret = await this.$wyPageApi.requestServerApi(this.apiConfig.detail, body);
            if (ret) {
                this.dataForm = { ...this.dataForm, ...ret }; // 合并对象，覆盖相同字段;
            }
        },
        /**
         * 禁用日期函数
         * @param {string} time
         * @param {object} item
         */
        disabledDate(time, item) {
            return time.getTime() > Date.now() - 8.64e7; // 8.64e7 毫秒数代表一天
        },
        inputEvent(value, item) {
            if (item.event) {
                this[item.event](value, item);
            }
        },
        validateInputFloat(value, item) {
            // 使用正则表达式验证输入是否为浮点数
            const floatRegex = /^-?\d+(\.\d+)?$/;
            while (value && !floatRegex.test(value) && value[value.length - 1] !== '.') {
                value = value.slice(0, value.length - 1); // 移除非法字符
            }
            this.dataForm[item.field] = value;
        },

        /**
         * 下面的方法，属于自定义函数，可以在页面配置中配置动态调用
         */

        /**
         * 自定义库存单位
         */
        customizeStockUnit() {
            let unitArr = this.dataForm.unit_display_name.split("/");
            if (unitArr.length < 2) {
                return;
            }
            this.dataForm.unit = unitArr[0];
            this.dataForm.packing_unit = unitArr[1];
        },
    },
};
</script>

<style scoped lang="scss">
.wy-page-detail-container {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    .wy-page-name {
        width: 100%;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        line-height: 1.5;
        margin: 20px auto;
    }
    .wy-content-rbox {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .wy-content-cbox {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
    }
    .wy-row-box {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        .wy-item-box {
            flex: 1; /* 每个子元素占据等分的宽度 */
        }
    }
    .wy-column-box {
        display: flex;
        flex-direction: column;
    }
    .wy-item-box {
        display: flex;
        flex-direction: row;
        min-width: 360px;
        ::v-deep .el-form-item__label {
            display: inline-block;
            min-width: 140px;
            white-space: nowrap;
            text-align: right;
            color: #a0a0a0;
        }
        ::v-deep .el-form-item__content {
            width: 100%;
            display: flex;
            align-items: center;
        }
        ::v-deep .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
            width: 100%;
        }
        ::v-deep .el-select {
            width: 100%;
        }
        .item-tips {
            font-size: 12px;
            color: red;
            margin-left: 8px;
            line-height: 1.2;
        }
        &.show-item {
            margin-bottom: 0;
        }
        &.json-item {
            pre {
                line-height: 1.6;
                background-color: #f5f5f5;
                border-radius: 4px;
                border: 1px solid #ccc;
                padding: 15px;
                max-height: 300px;
                overflow: auto;
            }
        }
        &.top {
            flex-direction: column;
            ::v-deep .el-form-item__label {
                text-align: left;
            }
        }
    }
    ::v-deep .el-form.el-form--label-top {
        .wy-item-box {
            flex-direction: column;
            .el-form-item__label {
                text-align: left;
                padding: 0;
            }
        }
    }
    .wy-btn-box {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
}
</style>